import _classnames from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * An item in the DeepMenu component
 */
function DeepMenuItem({ active, className, disabled, href, hrefProps, onClick, text }) {
  const classes = _classnames('DeepMenu__item', className, {
    'DeepMenu__item--active': active,
    'DeepMenu__item--disabled': disabled,
  });

  return href && !disabled ? (
    <a className={classes} onClick={onClick} href={href} {...hrefProps}>
      {text}
    </a>
  ) : (
    <div
      className={classes}
      onClick={disabled ? null : onClick}
      onKeyUp={disabled ? null : onClick}
    >
      {text}
    </div>
  );
}

DeepMenuItem.propTypes = {
  /**
   * Whether or not the `DeepMenuItem` is active
   */
  active: PropTypes.bool,

  /**
   * Whether or not the `DeepMenuItem` is disabled
   */
  disabled: PropTypes.bool,

  /**
   * A space-delimited list of class names to pass along to the `DeepMenuItem` component
   */
  className: PropTypes.string,

  /**
   * If set, item is an anchor element with href set
   */
  href: PropTypes.string,

  /**
   * If href is set, this allows any additional href props
   */
  // eslint-disable-next-line react/forbid-prop-types
  hrefProps: PropTypes.object,

  /**
   * Function called upon click; returns event object
   */
  onClick: PropTypes.func,

  /**
   * Text to appear in the menu item
   */
  text: PropTypes.string,
};

DeepMenuItem.defaultProps = {
  active: false,
  disabled: false,
  hrefProps: {},
  onClick: () => {},
  text: '',
  className: '',
  href: undefined,
};

export default DeepMenuItem;
